import React from 'react'
import PropTypes from 'prop-types'
import { concatClasses } from '../../utils/fns'

const getInputClassName = (classes) => concatClasses('', classes)

export const Input = React.memo(
  React.forwardRef((props, ref) => {
    const { as: Component, className, ...inputProps } = props

    return <Component ref={ref} className={getInputClassName(className)} {...inputProps} />
  }),
)

Input.displayName = 'Input'

Input.propTypes = {
  as: PropTypes.string,
  className: PropTypes.string,
}

Input.defaultProps = {
  as: 'input',
  type: 'text',
  className: '',
}
